/*
Persistent search criteria retained by:
1) Make sure that all fields in every form has the value set
2) Fields are cleared when switching between tabs
 */

$(document).ready(function () {
    SearchPanel.initSearchPanel();
    $('input[type=radio][name=vin_type]').on('change', function () {
        switch ($(this).val()) {
            case 'single':
                SearchPanel.showSingle(true);
                break;
            case 'multiple':
                SearchPanel.showMultiple(true);
                break;
        }
    });

    $('input.date-range-picker').daterangepicker({
        autoApply: true,
        autoUpdateInput: false
    });

    $('input.date-range-picker').on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('MM/DD/YYYY') + ' - ' + picker.endDate.format('MM/DD/YYYY'));
    });

    $('input.date-range-picker').on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });
});

var SearchPanel = {
    initSearchPanel: function () {
        SearchPanel.singleText = $('#search_vin_single');
        SearchPanel.singleRadio = $('#search_vin_single_radio');
        SearchPanel.multipleText = $('#search_vin_multiple');
        SearchPanel.multipleRadio = $('#search_vin_multiple_radio');
        SearchPanel.advancedSearchType = $('#advancedSearchType');
        SearchPanel.onLoadSearchType = $('#onLoadSearchType');

        SearchPanel.handleTabs();

        //Clears the current form that is displayed
        $('.clearForm').on('click', function (event) {
            event.preventDefault();
            SearchPanel.clearForm(event.target.closest('form'));
        });

        //Clear the destination form when the tab is clicked
        $('.search-tab').on('click', function (event) {
            event.preventDefault();
            var eleFormId = event.target.attributes['href'].value.split('#')[1] + 'Form';
            SearchPanel.clearForm(document.getElementById(eleFormId));
            if (eleFormId == 'advancedSearchForm') {
                SearchPanel.showSingle(true);
            }
        });
    },

    handleTabs: function () {
        if (SearchPanel.onLoadSearchType.val() == 'advanced_single') {
            SearchPanel.showSingle(false);
        } else if (SearchPanel.onLoadSearchType.val() == 'advanced_multiple') {
            SearchPanel.showMultiple(false);
        } else {
            SearchPanel.showSingle(false);
            SearchPanel.showBasic(true);
        }
    },

    clearForm: function (ele) {
        try {
            var formEles = ele.elements;
            for (i = 0; i < formEles.length; i++) {
                field_type = formEles[i].type.toLowerCase();
                switch (field_type) {
                    case "text":
                    case "password":
                    case "textarea":
                    ///case "hidden":
                    case "search":
                    case "date":
                        formEles[i].value = "";
                        break;
                    case "radio":
                        SearchPanel.showSingle(true);
                        break;
                    case "checkbox":
                        if (!(formEles[i].checked)) {
                            formEles[i].checked = true;
                        }
                        break;
                    case "number":
                        formEles[i].value = null;
                        break;
                    case "select-one":
                    case "select-multi":
                        formEles[i].selectedIndex = -1;
                        break;
                    default:
                        break;
                }
            }
        } catch (e) {
            // do nothing
        }


    },

    clearVinValues: function () {
        SearchPanel.singleText.val('');
        SearchPanel.multipleText.val('');
    },

    showSingle: function (clear) {
        if (clear) {
            SearchPanel.clearVinValues();
        }
        $('#vin_search_panel a[href="#advancedSearch"]').tab('show');
        SearchPanel.singleRadio.prop('checked', true);
        SearchPanel.multipleText.hide();
        SearchPanel.singleText.show();
        SearchPanel.advancedSearchType.val('advanced_single');

    },

    showMultiple: function (clear) {
        if (clear) {
            SearchPanel.clearVinValues();
        }
        $('#vin_search_panel a[href="#advancedSearch"]').tab('show');
        SearchPanel.multipleRadio.prop('checked', true);
        SearchPanel.multipleText.show();
        SearchPanel.singleText.hide();
        SearchPanel.advancedSearchType.val('advanced_multiple');
    },

    showBasic: function (clear) {
        if (clear) {
            SearchPanel.clearVinValues();
        }
        $('#vin_search_panel a[href="#basicSearch"]').tab('show');
    }
};